export const EducatorActionTypes = {
    GET_EDUCATOR_INFO: 'GET_EDUCATOR_INFO',
    GET_EDUCATOR_INFO_METADATA: 'GET_EDUCATOR_INFO_METADATA',
    SET_EDUCATOR_QUERIES: 'SET_EDUCATOR_QUERIES',
    GET_EDUCATOR_INFO_DETAIL: 'GET_EDUCATOR_INFO_DETAIL',
    SET_EDUCATOR_LOADING_MODAL: 'SET_EDUCATOR_LOADING_MODAL',
    GET_PARENT_STATES: 'GET_PARENT_STATES',
    GET_PARENT_CITIES: 'GET_PARENT_CITIES',
    GET_STUDENT_STATES: 'GET_STUDENT_STATES',
    GET_STUDENT_CITIES: 'GET_STUDENT_CITIES',
    CREATE_EDUCATOR_INFO: 'CREATE_EDUCATOR_INFO',
    UPDATE_EDUCATOR_INFO: 'UPDATE_EDUCATOR_INFO',
    GET_DYNAMIC_CITY: 'GET_DYNAMIC_CITY',
}
